module.exports = __webpack_public_path__ + "img/19.68f68945.jpg";